export const eventTypes = {
  PAGE_VIEW: 'page_view',
  BUY_ONLINE_SUBMIT: 'buy_online_submit',
  BOOK_APPOINTMENT_SUBMIT: 'book_appointment_submit',
  EMAIL_SUBMIT: 'email_submit',
  BUY_ONLINE: 'buy_online',
};

export default function dispatchDataLayerEvent(payload) {
  window.dispatchEvent(new CustomEvent('dataLayerEvent', { detail: payload }));
}



// WEBPACK FOOTER //
// ./src/utils/dispatchDataLayerEvent.js